import { Component, inject } from '@angular/core';
import { ButtonsModule, CheckboxModule, DialogModule, DialogService, FormFieldModule, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { RegionService } from '@lib/region/region.service';
import { createZoneFormGroup, StoreZoneRequest, ZoneSingleResponse } from '@lib/api/models/zone';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';

export interface RegionData {
    id: string;
    name: string;
}

@Component({
    selector: 'app-add-region-zone-dialog',
    imports: [
        ButtonsModule,
        CheckboxModule,
        DialogModule,
        ErrorPanelComponent,
        ReactiveFormsModule,
        FormFieldModule,
        FormsModule
    ],
    templateUrl: './add-region-zone-dialog.component.html',
    standalone: true,
    styleUrl: './add-region-zone-dialog.component.scss'
})

export class AddRegionZoneDialogComponent {

    private readonly _regionService = inject(RegionService);
    private readonly _snackBar = inject(SnackBarService);

    protected readonly data = inject<RegionData>(DIALOG_DATA);
    protected readonly dialogRef = inject<DialogRef>(DialogRef);

    protected readonly zoneFormGroup = createZoneFormGroup();

    addZoneRequest = new SendableRequest<ZoneSingleResponse, StoreZoneRequest>({
        request: payload => this._regionService.createZone(this.data.id, payload!),

        onSuccess: () => {
            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Zone created successfully',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });

            this.dialogRef.close();
        }
    });

    add() {

        if (this.zoneFormGroup.invalid) {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Please fill in all required fields',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
            return;
        }

        const zoneData = {
            'name': this.zoneFormGroup.value.name ?? '',
            'description': this.zoneFormGroup.value.description ?? '',
            'status': true
        };

        this.addZoneRequest.send(zoneData);
    }

    public static show(dialog: DialogService, data: RegionData) {
        return dialog.openDialog<DialogRef, RegionData>(AddRegionZoneDialogComponent, {
            data
        });
    }
}
